import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Pagination } from '../models/pagination.model';
import { Sorting } from '../models/sorting.model';
import { SubscriptionFilters } from '../models/subscription-filters.model';

@Injectable({
  providedIn: 'root',
})
export class UrlFormatterService {
  format(
    pagination: Pagination,
    subscriptionFilters: SubscriptionFilters,
    sorting: Sorting
  ): HttpParams {
    let params: HttpParams = new HttpParams();
    if (pagination) {
      params = this.addPaginationToHttpParams(pagination, params);
    }
    params = this.addFiltersToHttpParams(subscriptionFilters, params);
    params = this.addSortingToHttpParams(sorting, params);
    return params;
  }

  public addPaginationToHttpParams(
    pagination: Pagination,
    httpParams: HttpParams
  ): HttpParams {
    httpParams = httpParams.set(
      'offSet',
      String(pagination.pageIndex * pagination.pageSize)
    );
    httpParams = httpParams.set('maxResult', String(pagination.pageSize));
    return httpParams;
  }

  public addFiltersToHttpParams(
    subscriptionFilters: SubscriptionFilters,
    httpParams: HttpParams
  ): HttpParams {
    if(subscriptionFilters.statuses){
      httpParams = httpParams.append('status', subscriptionFilters.statuses);
    }
    if(subscriptionFilters.accessModes){
      httpParams = httpParams.append('accessMode', subscriptionFilters.accessModes);
    }
    if(subscriptionFilters.editors){
      httpParams = httpParams.append('editor', subscriptionFilters.editors);
      httpParams = httpParams.append('editType', subscriptionFilters.editType);
      httpParams = httpParams.append('editBranchCode', subscriptionFilters.editBranchCode);
      httpParams = httpParams.append('editCompanyRegister', subscriptionFilters.editCompanyRegister);
    }
    if(subscriptionFilters.startSubmittedDate){
          httpParams = httpParams.append('startSubmittedDate', subscriptionFilters.startSubmittedDate);
    }
    if(subscriptionFilters.endSubmittedDate){
      httpParams = httpParams.append('endSubmittedDate', subscriptionFilters.endSubmittedDate);
    }


    subscriptionFilters.operators.forEach((operator) => {
      httpParams = httpParams.append('oslSiret', operator.siret);
      httpParams = httpParams.append('oslBranchCode', operator.branchCode);
      httpParams = httpParams.append('oslType', operator.type);
    });

    subscriptionFilters.approaches.forEach((approach) => {
      httpParams = httpParams.append('processCode', approach);
    });

    if (subscriptionFilters.siret) {
      httpParams = httpParams.set('siret', subscriptionFilters.siret);

    }
    if(subscriptionFilters.startSubmittedDate){
      httpParams = httpParams.set('startSubmittedDate', subscriptionFilters.startSubmittedDate);
    }
    if(subscriptionFilters.endSubmittedDate){
      httpParams = httpParams.set('endSubmittedDate', subscriptionFilters.endSubmittedDate);
    }
    return httpParams;
  }

  public addSortingToHttpParams(
    sorting: Sorting,
    httpParams: HttpParams
  ): HttpParams {
    if (sorting.orderBy) {
      httpParams = httpParams.set('orderBy', sorting.orderBy);
      httpParams = httpParams.set('ascending', String(sorting.ascending));
    }

    return httpParams;
  }
}
